import React, { useEffect } from "react";

export default function WebDropdownStyle(props) {
  const {
    companyAndLocations,
    selectedLocation,
    setSelectedLocation,
    setShowModal,
    filterBookedItemsByLocation,
  } = props;

  const flattenedLocations = companyAndLocations.flatMap((company) =>
    company.locations.map((location) => ({
      ...location,
      companyId: company.id,
      companyName: company.companyName,
    }))
  );

  useEffect(() => {
    if (flattenedLocations.length === 1) {
      const onlyLocation = flattenedLocations[0];
      setSelectedLocation(onlyLocation);
      filterBookedItemsByLocation(onlyLocation);
      // setShowModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onValueChange = (event) => {
    const locationId = event.target.value;
    const selected = flattenedLocations.find((loc) => loc.id === locationId);
    if (selected) {
      setSelectedLocation(selected);
      filterBookedItemsByLocation(selected);
      setShowModal(false);
    }
  };

  return (
    <div style={styles.container}>
      {flattenedLocations.length === 1 ? (
        <p style={styles.label}>
          Your default location is: <br />
          <span style={styles.boldText}>
            {flattenedLocations[0].streetName}, {flattenedLocations[0].suburb}
          </span>
        </p>
      ) : (
        <>
          <p style={styles.label}>
            Your selected location is: <br />
            <span style={styles.boldText}>
              {selectedLocation?.streetName}, {selectedLocation?.suburb}
            </span>
          </p>

          <p style={styles.label}>Change location to:</p>
          <div style={styles.pickerContainer}>
            <select
              value={selectedLocation?.id ?? ""}
              onChange={onValueChange}
              style={styles.select}
            >
              <option value="" disabled>
                Select location
              </option>
              {flattenedLocations.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.streetName}, {location.suburb}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: 20,
    fontFamily: "Arial, sans-serif",
  },
  label: {
    fontSize: 16,
    marginBottom: 10,
  },
  boldText: {
    fontWeight: "bold",
  },
  pickerContainer: {
    border: "1px solid #ccc",
    borderRadius: 5,
    overflow: "hidden",
    display: "inline-block",
  },
  select: {
    fontSize: 16,
    padding: "8px 12px",
    border: "none",
    outline: "none",
    appearance: "none",
    backgroundColor: "white",
    cursor: "pointer",
    minWidth: 200,
  },
};
